export default __webpack_public_path__ + "static/media/maida.fd6e1ce1.svg";